import React from 'react'
import StepTemplate from './StepTemplate'
import { Pregunta, PREGUNTAS } from '../../data/ocean'

const CONSIGNAS: Pregunta[] = PREGUNTAS.slice(11, 22)

export default function Step2() {
  return <StepTemplate step={2} consignas={CONSIGNAS} />
}
